import {l} from "types/typescriptdefinisjoner_lederplan";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Debugger} from "debug";
import {Filer} from "../Filer";
import {IPromise, IQService} from "angular";


const debug: Debugger = require('debug')('ProtokollRessurs');

export class ProtokollRessurs {
    static regNavn = 'protokollRessurs';

    static forInjisering() {
        return [
            regNavn.ng.$resource,
            regNavn.ng.$q,
            regNavn.ngFileUpload.Upload,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            Filer.regNavn,
            ProtokollRessurs
        ]
    }

    private ressurs: ng.resource.IResourceClass<any>;

    constructor(private $resource: ng.resource.IResourceService,
                private $q: IQService,
                private ngFileUpload: angular.angularFileUpload.IUploadService,
                private ressursFeilhåndtering: RessursFeilhåndtering,
                private gettextCatalog: gettextCatalog,
                private filer: Filer) {
        this.ressurs = $resource<any>('/api/protokoll', {}, {
            hent: {method: 'GET', url: '/api/protokoll/:moeteId', params: {moeteId: '@moeteId'}},
            deltakere: {method: 'GET', url: '/api/protokoll/:moeteId/deltakere', params: {moeteId: '@moeteId'}},
            finnMøteProtokolldokumentISakGjelderFor: {method: 'GET', url: '/api/protokoll/finnMoeteProtokolldokumentISakGjelderFor/:dokumentId', params: {dokumentId: '@dokumentId'}},
            finnMøteProtokolldokumentGjelderFor: {method: 'GET', url: '/api/protokoll/finnMoeteProtokolldokumentGjelderFor/:dokumentId', params: {dokumentId: '@dokumentId'}},
            sendTilSignering: {method: 'POST', url: '/api/protokoll/:moeteId/sendTilSignering', params: {moeteId: '@moeteId'}},
            oppdaterProtokoll: {method: 'POST', url: '/api/protokoll/:moeteId/oppdaterProtokoll', params: {moeteId: '@moeteId'}},
            låsOppProtokoll: {method: 'POST', url: '/api/protokoll/:moeteId/laasOppProtokoll', params: {moeteId: '@moeteId'}},
            publiserProtokoll: {method: 'POST', url: '/api/protokoll/:moeteId/publiser', params: {moeteId: '@moeteId'}}
        });
    }

    hent(møteId: string): l.ProtokollDetaljerModell {
        debug('hent', møteId);
        return this.ressurs['hent'](
            {moeteId: møteId},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke hente protokolldetaljer'))
        );
    }

    deltakere(møteId: string): l.ProtokollførtMøtedeltakereModell {
        debug('deltakere', møteId);
        return this.ressurs['deltakere'](
            {moeteId: møteId},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke hente protokollførte møtedeltakere'))
        );
    }

    finnMøteProtokolldokumentISakGjelderFor(protokolldokumentISakId: string): l.EntitetIdRespons {
        debug('finnMøteProtokolldokumentISakGjelderFor', protokolldokumentISakId);
        return this.ressurs['finnMøteProtokolldokumentISakGjelderFor'](
            {dokumentId: protokolldokumentISakId},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke hente møte-id basert på protokolldokument-id'))
        );
    }

    finnMøteProtokolldokumentGjelderFor(protokolldokumentISakId: string): l.EntitetIdRespons {
        debug('finnMøteProtokolldokumentGjelderFor', protokolldokumentISakId);
        return this.ressurs['finnMøteProtokolldokumentGjelderFor'](
            {dokumentId: protokolldokumentISakId},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke hente møte-id basert på protokolldokument-id'))
        );
    }

    sendTilSignering(møteId: string, spesifikasjon: l.SendProtokollsigneringsInvitasjonSpesifikasjon): l.OkRespons {
        debug("sendTilSignering", møteId, spesifikasjon);
        return this.ressurs['sendTilSignering'](
            _.defaults({moeteId: møteId}, spesifikasjon),
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke sende protokoll til signering'))
        );
    }

    oppdaterProtokoll(spesifikasjon: l.ProtokollSpesifikasjon): l.ValideringsresultatModell<l.MøteProtokollValideringsfeil> {
        debug('oppdaterProtokoll', spesifikasjon);
        return this.ressurs['oppdaterProtokoll'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke lagre protokoll'))
        );
    }

    låsOppProtokoll(møteId: string, årsak: string) {
        debug('låsOppProtokoll', møteId);
        return this.ressurs['låsOppProtokoll'](
            {moeteId: møteId, aarsak: årsak},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke låse opp protokoll'))
        );
    }

    publiserProtokoll(møteId: string, spesifikasjon: l.MøtepubliseringSpesifikasjon): l.MøteModell {
        debug("publiserProtokoll", møteId, spesifikasjon);
        return this.ressurs['publiserProtokoll'](
            _.defaults({moeteId: møteId}, spesifikasjon),
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke publisere protokoll'))
        );
    }

    registrerEksterntSignertProtokoll(fil: File, møteId: string): EksterntSignertProtokollOpplasting {
        return new EksterntSignertProtokollOpplasting(fil, møteId, this.ngFileUpload, this.$q, this.filer);
    }

    //hjelpemetoder

    /** Mulige verdier for l.SigneringStatus enum med label */
    //@todo SIG EndringshendelseKontroller.oversettSigneringStatus inneholder også oversettelser..
    signeringStatusLabels(): { [verdi: number]: string } {
        const valg = <any>{};
        /// SigneringStatus.ikkeAktivert label
        valg[l.SigneringStatus.ikkeAktivert] = this.gettextCatalog.getString('ikke signert');
        /// SigneringStatus.tilSignering label
        valg[l.SigneringStatus.tilSignering] = this.gettextCatalog.getString('til signering');
        /// SigneringStatus.delvisSignert label
        valg[l.SigneringStatus.delvisSignert] = this.gettextCatalog.getString('delvis signert');
        /// SigneringStatus.signert label
        valg[l.SigneringStatus.signert] = this.gettextCatalog.getString('signert');
        /// SigneringStatus.signertOgKonvoluttert label
        valg[l.SigneringStatus.signertOgKonvoluttert] = this.gettextCatalog.getString('signering komplett');
        /// SigneringStatus.eksterntSignert label
        valg[l.SigneringStatus.eksterntSignert] = this.gettextCatalog.getString('eksternt signert');

        return valg;
    }

    private håndterFeil(melding: () => string) {
        return this.ressursFeilhåndtering.håndterRequestFeil(melding);
    }
}

export class EksterntSignertProtokollOpplasting {
    jobb;
    progresjon = 0;
    mimetype: string;

    constructor(public fil: File, public møteId: string, private ngFileUpload: any /*angular.angularFileUpload.IUploadService*/, private $q:IQService, private filer: Filer) {
        this.mimetype = fil.type || this.filer.finnMimetypeBasertPåFilendelse(fil);
    }

    startOpplasting(): IPromise<void> {
        const defered = this.$q.defer<void>();

        this.jobb = this.ngFileUpload.upload(
            {
                url: `/api/protokoll/${this.møteId}/registrerSignertProtokolldokument`,
                method: 'POST',
                data: {
                    file: this.fil,
                    info: this.ngFileUpload.json({
                        stoerrelse: this.fil.size,
                        type: this.mimetype,
                        filnavn: this.fil.name
                    })
                },
                //sørger for at properties i 'info' sendes med json-content-type
                //merk at vi ved å registrere vår egen formDataAppender ikke lenger
                //kan benytte ng-file-uploads resume funksjonalitet da Upload.addFieldToFormData
                //ikke lenger blir kalt (se Upload.digestConfig)
                formDataAppender: (formData: FormData, key, val) => {
                    if (key == "info")
                        formData.append(key, new Blob([val], {type: 'application/json'}));
                    else
                        formData.append(key, val, val.ngfName || val.name);
                },
            })
            .progress(evt => this.progresjon = Math.floor(100.0 * evt.loaded / evt.total))
            .success(okRespons => {
                defered.resolve();
            })
            .error(e => {
                defered.reject(e);
            });

        return defered.promise;
    }

    avbryt() {
        if (this.jobb) this.jobb.abort();
    }
}
